const constants = {
	cookieLastVisited: 'lt-last-visited-page',
	cookieSsoId: 'LTFSSOIDCookie',
	cookieSsoCreated: 'LTFSSO-created',
	cookieAuthToken: 'LTF-T',
	cookieSsoExpires: 0, // session cookie
	cookieProfileTokenExpires: 6480000, // 75 days
	cookieProfileToken: 'ltf-profile',
	cookieLtSession: 'lt-session',
	cookieLtAuthorization: 'lt-auth',
	cookieLtAuthorizationV2: 'lt-authorization',
	cookieLtAuthentication: 'lt-authentication',
	cookieAemToken: 'login-token',
	cookieSpabizToken: 'lt-member-spabiz-token',
	cookieSpabizTokenExpires: 6480000, // 75 days
	cookieCorpMembership: 'corpMembership',
	paramSso: 'sso',
	paramAuthToken: 'ct',
	paramProfileToken: 'ptoken',
	expiredSsoMessage: 'Expired SSO Session.',
	profileNotFoundMessage: 'Profile does not exist.',
	invalidRequestMessage: 'Bad Request',
	subOptimalCookie: 'optimal-exp',
	slingMap: '/content/lt/en_us',
	subOptimalUrl: 'http://mylt-error.lifetime.life/suboptimal.html',
	recentClubsMetaTypeName: 'recentClubs',
	metersToMilesRatio: 0.000621371192,
	marketingCloudInstanceId: 'A711776A5245B1150A490D44@AdobeOrg',
	loginResoucePageDriver: 'loginResource',
	memberState: {
		unknown: 'UNKNOWN',
		authenticated: 'AUTHENTICATED',
		unauthenticated: 'UNAUTHENTICATED',
		remembered: 'REMEMBERED'
	},
	memberDetailsStorageKey: 'lt-member-details',
	clubsStorageKey: 'lt-clubs',
	clubSearchSource: {
		filterApply: 'filter-apply',
		locationSharing: 'location-sharing',
		lowAccuracySearch: 'low-accuracy-search',
		mapDrag: 'map-drag',
		omniboxBlueBanner: 'omnibox:blue-banner',
		omniboxFindAClub: 'omnibox:find-a-club'
	},
	defaultAlertNotificationId: 'default-alert',
	notificationPrefix: 'alert-notification-',
	defaultDirectionsUrl: 'http://www.google.com/maps/dir/Current+Location/',
    employeeReferralFeatureFlagId: 'employeeReferral',
    employeeReferralOmsMagentoApiFeatureFlagId: 'memberReferralNewOMSService',
	experienceTypeMember: 'member',
	experienceTypeProspect: 'prospect',
	experienceTypeLthealth: 'lthealth',
	experienceTypeWork: 'work',
	experienceTypeWorkProspect: 'work-prospect',
	experienceTypeSport: 'sport',
	experienceTypeSwim: 'swim',
	experienceTypeMind: 'mind',
    experienceTypeLiving: 'living',
	experienceTypeToken: 'token',
	apiProfileUrl: 'user-profile/api/',
	apiProfileUrlV2: 'user-profile/profile/',
	domainCookiesFeatureFlagId: 'domaincookies',
    presentNormalJoiningFeeFeatureFlagId: 'presentNormalJoiningFee',
    forceWaitListCtaFeatureFlag: 'forceWaitListCta',
	ltDomainName: '.lifetime.life',
	authV2FeatureFlagId: 'authv2',
	apiAuthUrl: 'auth/',
	apiAuthUrlV2: 'auth/v2/',
	biosBaseUrl: 'ux/biosadmin/',
	memberReferralCookieName: 'memberReferral',
	// TODO: move this into club data or club cache responses
	clubType: {
		club: [1, 2],
		swim: 8,
		sport: 9,
		work: 10
	},
	loadingSpinnerLgClass: '.loading-spinner-lg',
	loadingSpinnerLgString: 'loading-spinner-lg',
	hiddenXsUpString: 'hidden-xs-up',
	studentReactivationAlertEligible: 'lt-student-reactivation-alert-eligible',
	dismissedStudentReactivateNotification: 'lt-dismissed-student-reactivate-notification',
	onHoldReactivationAlertEligible: 'lt-onhold-reactivation-alert-eligible',
	dismissedOnHoldReactivateNotification: 'lt-dismissed-onhold-reactivate-notification',
	dismissedLimitedAccessModal: 'lt-dismissed-limited-access-notification',
	reactivationPendingStorageId: 'lt-reactivation-pending',
	promotionURLParam: 'promotionName',
	storedClubData: 'lt-club-data',
	mmsFailureFlag: 'mmsFailure',
	pegaServiceTimeout: 20000,
	eventCategoryClick: 'click',
	biosSpringApiFlag: 'biosSpringApi'
};
export default constants;

